import { createSystem, defaultConfig } from '@chakra-ui/react';

export const theme = createSystem(defaultConfig, {
  globalCss: {
    'html, body': {
      backgroundColor: '#eaeaea',
      color: '#444444',
      fontFamily: `'Circular Std', sans-serif`,
    },
  },
});

export default theme;
